import AnimationController from '../../assets/js/controllers/animation';
import ResizeController from '../../assets/js/controllers/resize';
import ScrollController from '../../assets/js/controllers/scroll';

import SkrolliteChild from './skrollite-child';

import { mq } from '../../assets/js/helpers';

/*

Options:

data-skrollite-delay (in seconds)

*/

export default class Skrollite {

	static selector = '[data-skrollite]';

	// class variables

	// child params (can be altered by optional data attributes)

	config = {
		isVerbose: false,		// data-skrollite-verbose
		viewportGutters: {
			top: 100,
			bottom: 150
		}
	};

	controllers = {
		animation: null,
		resize: null
	};

	coords = {
		height: 0
	};

	el = {};

	flags = {
		isActive: false,
		isMobile: false,
		isTablet: false,
		isDesktop: false
	};

	modules = {
		skrollites: []
	};

	// constructor

	constructor() {
		this.initialize();
	}

	// init

	initialize() {
		this.id = 0;
		this.#addEventListeners();
	}

	//

	#addEventListeners = () => {
		this.controllers.animation = AnimationController.set({
			update: this.#onAnimationUpdate,
			render: this.#onAnimationRender
		});

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		AnimationController.clear(this.controllers.animation);
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	pageUpdate = () => {
		this.#gather();
	}

	pageOut = () => {
		this.disable();
	}

	pageIn = () => {
		this.enable();
	}

	// controller methods

	#onResizeUpdate = () => this.#measure();

	#onResizeRender = () => { }

	// scroll

	#onAnimationUpdate = () => {
		if (ScrollController.scrolling && this.flags.isActive) {
			return this.#update();
		}
		return false;
	}

	#onAnimationRender = () => {
		this.#render();
	}

	// update / render

	#update = () => {
		let isChanged = false;

		for (let i = 0; i < this.modules.skrollites.length; i++) {
			const skrolliteChild = this.modules.skrollites[i];
			const curChanged = skrolliteChild.update();
			if (curChanged) {
				isChanged = true;
			}
		}

		return isChanged;
	}

	#render = () => {
		for (let i = 0; i < this.modules.skrollites.length; i++) {
			const skrolliteChild = this.modules.skrollites[i];
			skrolliteChild.render();
		}
	}

	// enable / disable

	enable() {
		if (!this.flags.isActive) {
			this.flags.isActive = true;
			this.#gather();
		}
	}

	disable() {
		if (this.flags.isActive) {
			this.flags.isActive = false;
			this.#disconnect();
		}
	}

	//

	#gather = () => {
		this.#disconnect();

		const $skrollites = document.body.querySelectorAll('[data-skrollite]');
		for (let i = 0; i < $skrollites.length; i++) {
			const $skrollite = $skrollites[i];

			// check for data params

			const viewportGutterTopParam = this.#validateNumberParam($skrollite.dataset.skrolliteGutterTop);
			const viewportGutterBottomParam = this.#validateNumberParam($skrollite.dataset.skrolliteGutterBottom);

			const childParams = {
				skrollite: this,
				viewportGutters: {
					top: (viewportGutterTopParam !== false && viewportGutterTopParam >= 0) ? viewportGutterTopParam : this.config.viewportGutters.top,
					bottom: (viewportGutterBottomParam !== false && viewportGutterBottomParam >= 0) ? viewportGutterBottomParam : this.config.viewportGutters.bottom
				},
				isVerbose: typeof $skrollite.dataset.skrolliteVerbose !== 'undefined' ? true : this.config.isVerbose
			};

			//

			const skrollite = new SkrolliteChild($skrollite, { ...this.config, ...childParams });
			skrollite.setResizeFlags(this.flags.isMobile, this.flags.isTablet, this.flags.isDesktop);
			this.modules.skrollites.push(skrollite);
		}

		this.#measure();
		this.#update();
		this.#render();
	}

	// check config param

	#validateNumberParam = (param) => {
		if (typeof param !== 'undefined') {
			const floatParam = parseFloat(param);
			if (!isNaN(floatParam)) {
				return floatParam;
			}
		}
		return false;
	}

	#measure = () => {
		let isChanged = false;

		if (mq('medium')) {
			if (!this.flags.isDesktop) {
				this.flags.isMobile = false;
				this.flags.isTablet = false;
				this.flags.isDesktop = true;
				isChanged = true;
			}
		} else if (mq('small') && !mq('medium')) {
			if (!this.flags.isTablet) {
				this.flags.isMobile = false;
				this.flags.isTablet = true;
				this.flags.isDesktop = false;
				isChanged = true;
			}
		} else {
			if (!this.flags.isMobile) {
				this.flags.isMobile = true;
				this.flags.isTablet = false;
				this.flags.isDesktop = false;
				isChanged = true;
			}
		}

		for (let i = 0; i < this.modules.skrollites.length; i++) {
			const skrollite = this.modules.skrollites[i];
			skrollite.setResizeFlags(this.flags.isMobile, this.flags.isTablet, this.flags.isDesktop);
			skrollite.measure();
		}

		return isChanged;
	}

	#disconnect = () => {
		for (let i = 0; i < this.modules.skrollites.length; i++) {
			const skrolliteChild = this.modules.skrollites[i];
			skrolliteChild.destroy();
		}

		this.modules.skrollites = [];
	}

	//

	destroy() {
		this.#removeEventListeners();
		this.#disconnect();
	}

}
